import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'lin-badge',
  template: `
    <lin-tooltip [class.small]="size === 'small'" class="tooltip medium" [label]="title">
      @if (color) {
        <div class="container" [style.background-color]="color">
          <ng-container *ngTemplateOutlet="badgeTitle"></ng-container>
        </div>
      }
      @if (!color) {
        <ng-container *ngTemplateOutlet="badgeTitle"></ng-container>
      }
    </lin-tooltip>

    <ng-template #badgeTitle>
      <div class="text" [style.color]="textColor">{{ title }}</div>
    </ng-template>
  `,
  styles: [
    `
      :host {
        display: flex;
        margin-bottom: 2px;
        cursor: pointer;
      }

      .text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 8px;
        border-radius: 3px;
      }

      .medium {
        max-width: 200px;
        font-size: 1em;
      }

      .small {
        max-width: 100px;
        font-size: 0.9em;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BadgeComponent {
  textColor: string
  private _color: string

  @Input() set color(color: string) {
    this._color = color
    color && this.setTextColorByColor()
  }

  get color() {
    return this._color
  }

  @Input() title: string
  @Input() size: 'small' | 'medium' = 'medium'

  setTextColorByColor() {
    const color = this.color.charAt(0) === '#' ? this.color.substring(1, 7) : this.color
    const r = parseInt(color.substring(0, 2), 16)
    const g = parseInt(color.substring(2, 4), 16)
    const b = parseInt(color.substring(4, 6), 16)
    const whiteColor = 'var(--white-color)'
    const blackColor = 'var(--main-black-color)'

    this.textColor = r * 0.299 + g * 0.587 + b * 0.114 > 186 ? blackColor : whiteColor
  }
}
